import ConfirmResetPasswordPage from './ConfirmResetPasswordPage';

export default ConfirmResetPasswordPage;
